module.exports = __webpack_public_path__ + "img/solution3.1662cec2.png";